<template lang="pug">
.m-card
  .m-card-header(:id="'heading-ousp-' + childId" :data-bs-target="'#collapse-ousp-' + childId" :aria-controls="'collapse-ousp-' + childId" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ leagueName.trim() }}
  .m-card-body.collapse.show(:id="'collapse-ousp-' + childId" :aria-labelledby="'heading-ousp-' + childId" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        //- .m-card-match-wrapper
        //-   .m-card-match
        //-     .team(:class="source.team == 1 ? 'team-red' : ''")
        //-       .team-name {{ source.match[5] }}
        //-     TimePanel(:source="source" :mode="true")
        //-     .team(:class="source.team == 0 ? 'team-red' : ''")
        //-       .team-name {{ source.match[6] }}
        .m-card-odds
          .odds-wrapper
            .m-label-wrap
              .m-label F.T
            .odds-group
              .row
                template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
                  OddsItem.col(:odds="source['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count="0" :details="source" homeAway="1")
                template(v-else)
                  OddsDisabled.col
                template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
                  OddsItem.col(:odds="source['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count="0" :details="source" homeAway="2")
                template(v-else)
                  OddsDisabled.col
          .odds-wrapper
            .m-label-wrap
              .m-label H.T
            .odds-group
              .row
                template(v-if="source['ouh'] && source['ouh'][0] && source['ouh'][0][11] != 0 && source['ouh'][0][12] != 0 && source['ouh'][0][11] != '' && source['ouh'][0][12] != ''")
                  OddsItem.col(:odds="source['ouh'][0]" idx=12 :typ="oddsType" dataType="1" mode="ouh" label="over" count="0" :details="source" homeAway="1")
                template(v-else)
                  OddsDisabled.col
                template(v-if="source['ouh'] && source['ouh'][0] && source['ouh'][0][11] != 0 && source['ouh'][0][12] != 0 && source['ouh'][0][11] != '' && source['ouh'][0][12] != ''")
                  OddsItem.col(:odds="source['ouh'][0]" idx=11 :typ="oddsType" dataType="1" mode="ouh" label="under" count="0" :details="source" homeAway="2")
                template(v-else)
                  OddsDisabled.col
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import TimePanel from "@/components/mobile/main/timePanel";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    TimePanel
  },
  mixins: [mixinHDPOUOdds],
  props: {
    childId: {
      type: Number
    },
    mode: {
      type: Number
    }
  },
  computed: {
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  }
}
</script>
